/* ==========================================================================
   LE MEUBLE MALIN - script principal
   1. Utilitaires        4. Panier AJAX + tiroir
   2. Tracking TikTok    5. Page produit (variantes, galerie, quantite)
   3. Compte a rebours   6. Barre collante + divers
   ========================================================================== */
(function () {
  'use strict';

  var LMM = window.LMM || {};
  var CFG = LMM.cfg || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------ 1. utilitaires */
  function money(cents) {
    var v = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: LMM.currency || 'EUR'
      }).format(v);
    } catch (e) { return v.toFixed(2) + ' \u20AC'; }
  }

  var toastTimer;
  function toast(msg) {
    var t = $('#lmm-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2800);
  }

  function eventId(prefix) {
    return prefix + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function sha256(value) {
    if (!value || !window.crypto || !window.crypto.subtle) return Promise.resolve('');
    var data = new TextEncoder().encode(String(value).trim().toLowerCase());
    return window.crypto.subtle.digest('SHA-256', data).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) {
        return ('00' + b.toString(16)).slice(-2);
      }).join('');
    }).catch(function () { return ''; });
  }

  /* --------------------------------------------------- 2. tracking TikTok */
  var TT = {
    conf: window.LMM_TTQ || { enabled: false },
    ok: function () {
      return this.conf.enabled && this.conf.auto && typeof window.ttq !== 'undefined';
    },
    track: function (name, payload) {
      if (!this.ok()) return;
      var data = payload || {};
      if (this.conf.testCode) data.test_event_code = this.conf.testCode;
      var opts = {};
      if (this.conf.dedup) opts.event_id = eventId(name.toLowerCase());
      try { window.ttq.track(name, data, opts); } catch (e) { }
      if (this.conf.debug) console.log('[LMM][ttq]', name, data, opts);
    },
    identify: function (user) {
      if (!this.ok() || !this.conf.matching || !user) return;
      Promise.all([
        sha256(user.email), sha256((user.phone || '').replace(/[^\d+]/g, '')), sha256(user.external_id)
      ]).then(function (h) {
        var p = {};
        if (h[0]) p.email = h[0];
        if (h[1]) p.phone_number = h[1];
        if (h[2]) p.external_id = h[2];
        if (Object.keys(p).length) { try { window.ttq.identify(p); } catch (e) { } }
      });
    },
    contentsFromLineItems: function (items) {
      return (items || []).map(function (i) {
        return {
          content_id: String(i.variant_id || i.id),
          content_type: 'product',
          content_name: i.product_title || i.title,
          quantity: i.quantity || 1,
          price: (i.final_price || i.price || 0) / 100
        };
      });
    }
  };

  if (window.LMM_TTQ_USER) TT.identify(window.LMM_TTQ_USER);

  // ViewContent / ViewCategory / Search au chargement
  function firePageEvents() {
    if (window.LMM_ITEM) {
      TT.track('ViewContent', {
        contents: [{
          content_id: String(window.LMM_ITEM.content_id),
          content_type: 'product',
          content_name: window.LMM_ITEM.content_name,
          content_category: window.LMM_ITEM.content_category,
          quantity: 1,
          price: window.LMM_ITEM.price
        }],
        value: window.LMM_ITEM.price,
        currency: window.LMM_ITEM.currency
      });
    }
    if (window.LMM_CATEGORY) TT.track('ViewCategory', window.LMM_CATEGORY);
    if (window.LMM_SEARCH) TT.track('Search', window.LMM_SEARCH);
  }
  if (document.readyState !== 'loading') firePageEvents();
  else document.addEventListener('DOMContentLoaded', firePageEvents);

  // AddToCart : interception de toutes les requetes /cart/add (fetch + XHR)
  function trackAdd(payload) {
    var items = payload && payload.items ? payload.items : (payload && payload.id ? [payload] : []);
    if (!items.length) return;
    var contents = TT.contentsFromLineItems(items);
    var value = contents.reduce(function (s, c) { return s + (c.price * c.quantity); }, 0);
    TT.track('AddToCart', { contents: contents, value: value, currency: LMM.currency });
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var target = arguments[0];
      var url = typeof target === 'string' ? target : (target && target.url) || '';
      var promise = nativeFetch.apply(this, arguments);
      if (String(url).indexOf('/cart/add') !== -1) {
        promise.then(function (res) { return res.clone().json(); })
          .then(trackAdd).catch(function () { });
      }
      return promise;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__lmmUrl = url;
    return nativeOpen.apply(this, arguments);
  };
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (String(xhr.__lmmUrl || '').indexOf('/cart/add') !== -1) {
      xhr.addEventListener('load', function () {
        try { trackAdd(JSON.parse(xhr.responseText)); } catch (e) { }
      });
    }
    return nativeSend.apply(this, arguments);
  };

  // InitiateCheckout
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[name="checkout"], [data-checkout], .shopify-payment-button__button, a[href$="/checkout"]');
    if (!el) return;
    TT.track('InitiateCheckout', {
      contents: TT.contentsFromLineItems(LMM.cartItems || []),
      value: (LMM.cartTotal || 0) / 100,
      currency: LMM.currency
    });
  }, true);

  // Formulaires : newsletter, contact
  document.addEventListener('submit', function (e) {
    if (e.target.matches('.lmm-newsletter-form')) TT.track('Subscribe', {});
    if (e.target.matches('.lmm-contact-form')) TT.track('Contact', {});
  });

  /* -------------------------------------------- 3. compte a rebours livraison */
  var Countdown = {
    key: 'lmm_free_shipping_deadline',
    deadline: null,
    read: function () {
      var now = Date.now();
      var duration = (CFG.countdownMinutes || 15) * 60000;
      var reset = (CFG.countdownResetHours || 12) * 3600000;
      var stored = null;
      try { stored = window.localStorage.getItem(this.key); } catch (e) { }
      if (stored) {
        var end = parseInt(stored, 10);
        if (!isNaN(end) && now - end < reset) return end;
      }
      var fresh = now + duration;
      try { window.localStorage.setItem(this.key, String(fresh)); } catch (e) { }
      return fresh;
    },
    format: function (ms) {
      var total = Math.max(0, Math.floor(ms / 1000));
      var m = Math.floor(total / 60);
      var s = total % 60;
      return ('0' + m).slice(-2) + ':' + ('0' + s).slice(-2);
    },
    paint: function (label, expired) {
      // barre collante
      var bar = $('#lmm-sticky');
      var barText = $('#lmm-sticky-timer-text');
      if (barText) {
        barText.innerHTML = expired
          ? CFG.countdownExpired
          : CFG.countdownBefore + ' <b>' + label + '</b> ' + CFG.countdownAfter;
      }
      if (bar) bar.classList.toggle('is-expired', expired);

      // bloc livraison fiche produit
      $$('[data-lmm-ship]').forEach(function (block) {
        block.classList.toggle('is-expired', expired);
        var msg = block.querySelector('[data-lmm-ship-msg]');
        if (!msg) return;
        msg.innerHTML = expired
          ? 'L\u2019offre est termin\u00e9e : livraison factur\u00e9e <b>' + CFG.shippingFee + '</b>.'
          : 'Commandez dans <span class="lmm-ship__timer">' + label + '</span> et la livraison reste offerte (sinon ' + CFG.shippingFee + ').';
      });

      // bandeau panier (tiroir ou page)
      $$('[data-lmm-ship-banner]').forEach(function (el) {
        el.innerHTML = expired
          ? 'Livraison : ' + CFG.shippingFee
          : 'Livraison offerte \u2014 encore <b>' + label + '</b>';
      });
    },
    tick: function () {
      var left = this.deadline - Date.now();
      var expired = left <= 0;
      this.paint(this.format(left), expired);
      if (!expired) setTimeout(this.tick.bind(this), 1000);
    },
    start: function () {
      this.deadline = this.read();
      this.tick();
    }
  };
  Countdown.start();

  /* ------------------------------------------------- 4. panier + tiroir */
  var Drawer = {
    el: null,
    init: function () {
      this.el = $('#lmm-drawer');
    },
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lmm-noscroll');
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lmm-noscroll');
    },
    render: function (cart) {
      LMM.cartTotal = cart.total_price;
      LMM.cartItems = cart.items;
      $$('[data-lmm-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      var total = $('#lmm-drawer-total');
      if (total) total.textContent = money(cart.total_price);
      var body = $('#lmm-drawer-body');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<p class="lmm-empty">Votre panier est vide pour le moment.</p>';
        return;
      }
      body.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') : '';
        return '<div class="lmm-line">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="lmm-line__ph"></span>') +
          '<div>' +
          '<p class="lmm-line__t">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="lmm-line__v">' + item.variant_title + '</p>' : '') +
          '<p class="lmm-line__p">' + money(item.final_line_price) +
          ' <span class="lmm-note">x ' + item.quantity + '</span></p>' +
          '<button type="button" class="lmm-line__rm" data-lmm-remove="' + item.key + '">Retirer</button>' +
          '</div></div>';
      }).join('');
    },
    refresh: function () {
      var self = this;
      return fetch(LMM.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; })
        .catch(function () { });
    }
  };
  Drawer.init();
  if (CFG.cartType === 'drawer') Drawer.refresh();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lmm-drawer-close]')) { Drawer.close(); return; }
    var opener = e.target.closest('[data-lmm-open-cart]');
    if (opener) {
      e.preventDefault();
      Drawer.open();
      Drawer.refresh();
      return;
    }
    var remove = e.target.closest('[data-lmm-remove]');
    if (remove) {
      remove.disabled = true;
      fetch(LMM.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.getAttribute('data-lmm-remove'), quantity: 0 })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { Drawer.render(cart); })
        .catch(function () { remove.disabled = false; });
      return;
    }
    var checkout = e.target.closest('#lmm-drawer-checkout');
    if (checkout) window.location.href = CFG.checkoutUrl || '/checkout';
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Drawer.close();
  });

  // Que faire apres un ajout reussi : rediriger vers la page panier ou ouvrir le tiroir
  function afterAdd() {
    if (CFG.cartType === 'drawer') {
      toast('Ajout\u00e9 au panier');
      Drawer.open();
      Drawer.refresh();
      return;
    }
    window.location.href = LMM.routes.cart;
  }

  // Ajout au panier en AJAX pour tous les formulaires produit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-lmm-no-ajax')) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var initial = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Ajout en cours\u2026'; }

    fetch(LMM.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (button) { button.disabled = false; button.innerHTML = initial; }
        if (data.status) { toast(data.description || 'Article indisponible'); return; }
        afterAdd();
      })
      .catch(function () {
        if (button) { button.disabled = false; button.innerHTML = initial; }
        toast('L\u2019ajout a \u00e9chou\u00e9, r\u00e9essayez');
      });
  });

  // Ajout rapide depuis les cartes produit
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-lmm-quick-add]');
    if (!quick) return;
    var id = quick.getAttribute('data-lmm-quick-add');
    var initial = quick.innerHTML;
    quick.disabled = true;
    quick.innerHTML = 'Ajout\u2026';
    fetch(LMM.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        quick.disabled = false;
        quick.innerHTML = initial;
        if (data.status) { toast(data.description || 'Article indisponible'); return; }
        afterAdd();
      })
      .catch(function () { quick.disabled = false; quick.innerHTML = initial; });
  });

  /* ------------------------------------------------------ 5. page produit */
  var pdp = $('[data-lmm-pdp]');
  if (pdp) {
    // galerie
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-lmm-thumb]');
      if (!thumb) return;
      $$('[data-lmm-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      var main = $('[data-lmm-gallery-main] img');
      if (main) {
        main.src = thumb.getAttribute('data-src');
        main.srcset = '';
      }
    });

    // quantite
    $$('[data-lmm-qty]').forEach(function (widget) {
      var input = widget.querySelector('input');
      widget.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, btn.getAttribute('data-step') === 'up' ? value + 1 : value - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // variantes
    var variants = window.LMM_VARIANTS || [];
    function currentVariant() {
      var chosen = $$('[data-lmm-option]:checked').map(function (i) { return i.value; });
      if (!chosen.length) return variants[0];
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      })[0];
    }
    function applyVariant() {
      var v = currentVariant();
      if (!v) return;
      var idField = $('[data-lmm-variant-id]');
      if (idField) idField.value = v.id;

      var now = $('[data-lmm-price-now]');
      if (now) now.textContent = money(v.price);
      var was = $('[data-lmm-price-was]');
      if (was) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        was.textContent = onSale ? money(v.compare_at_price) : '';
        was.hidden = !onSale;
      }
      var save = $('[data-lmm-price-save]');
      if (save) {
        var diff = (v.compare_at_price || 0) - v.price;
        save.textContent = diff > 0 ? 'Vous \u00e9conomisez ' + money(diff) : '';
        save.hidden = diff <= 0;
      }
      var cut = $('[data-lmm-cut]');
      if (cut) {
        var pct = v.compare_at_price > v.price
          ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        cut.textContent = '-' + pct + '%';
        cut.hidden = pct <= 0;
      }
      var add = $('[data-lmm-add]');
      if (add) {
        add.disabled = !v.available;
        add.textContent = v.available ? add.getAttribute('data-label') : CFG.soldOutLabel;
      }
      var stickyBtn = $('#lmm-sticky-btn');
      if (stickyBtn) {
        stickyBtn.disabled = !v.available;
        stickyBtn.textContent = v.available ? CFG.stickyLabel : CFG.soldOutLabel;
      }
      var stickyPrice = $('#lmm-sticky-price');
      if (stickyPrice) {
        stickyPrice.innerHTML = money(v.price) +
          (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      }
      if (v.featured_image && v.featured_image.src) {
        var main = $('[data-lmm-gallery-main] img');
        if (main) { main.src = v.featured_image.src; main.srcset = ''; }
        var stickyThumb = $('#lmm-sticky-thumb');
        if (stickyThumb) stickyThumb.src = v.featured_image.src;
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { }
    }
    $$('[data-lmm-option]').forEach(function (input) {
      input.addEventListener('change', applyVariant);
    });
  }

  /* ------------------------------------------------- 6. barre collante */
  (function () {
    var bar = $('#lmm-sticky');
    if (!bar || !CFG.stickyEnabled) return;
    var isProduct = LMM.template === 'product';
    if (!isProduct && !CFG.stickyEverywhere) return;
    if (!isProduct) {
      var row = bar.querySelector('.lmm-sticky__row');
      if (row) row.remove();
    }

    var visible = false;
    var trigger = CFG.stickyTrigger || 450;

    function update() {
      var should = (window.pageYOffset || document.documentElement.scrollTop) > trigger;
      if (should && isProduct) {
        var mainBtn = $('[data-lmm-add]');
        if (mainBtn) {
          var r = mainBtn.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight - 80) should = false;
        }
      }
      if (should === visible) return;
      visible = should;
      bar.classList.toggle('is-visible', should);
      bar.setAttribute('aria-hidden', String(!should));
      document.body.classList.toggle('lmm-has-sticky', should);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var btn = $('#lmm-sticky-btn');
    if (btn) {
      btn.addEventListener('click', function () {
        var form = $('[data-lmm-pdp] form.lmm-product-form') || $('form[action*="/cart/add"]');
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  })();

  /* --------------------------------------------------------- 7. divers */
  var burger = $('[data-lmm-burger]');
  if (burger) {
    burger.addEventListener('click', function () {
      var nav = $('#lmm-nav');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  // horloge vente flash (remise a zero chaque nuit)
  $$('[data-lmm-clock]').forEach(function (clock) {
    function tick() {
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      var diff = Math.max(0, end - new Date());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      clock.innerHTML =
        '<div><b>' + ('0' + h).slice(-2) + '</b><span>HEURES</span></div>' +
        '<div><b>' + ('0' + m).slice(-2) + '</b><span>MIN</span></div>' +
        '<div><b>' + ('0' + s).slice(-2) + '</b><span>SEC</span></div>';
      setTimeout(tick, 1000);
    }
    tick();
  });

  // produits recemment consultes
  if (LMM.template === 'product' && window.LMM_ITEM) {
    try {
      var seen = JSON.parse(window.localStorage.getItem('lmm_recently_viewed') || '[]');
      seen = seen.filter(function (h) { return h !== window.LMM_ITEM.handle; });
      seen.unshift(window.LMM_ITEM.handle);
      window.localStorage.setItem('lmm_recently_viewed', JSON.stringify(seen.slice(0, 12)));
    } catch (e) { }
  }
})();
